import { FoldingLine, Page } from 'editor/src/store/design/types';

export interface CoverPanelLabel {
  title: string;
  x: number;
  width: number;
}

export interface CoverGuides {
  foldingLines: FoldingLine[];
  panelLabels: CoverPanelLabel[];
}

// A book cover is one wide page; preflight marks its spine with a `Content Spine` area and each
// cover part with a titled `Panel`. Both come from the production geometry, so the guides follow
// the spine width whenever the template is re-fetched for a new page count.
function getCoverGuides(page: Page): CoverGuides | undefined {
  const areas = (page.groups.content || []).filter((content) => content.type !== 'sample');
  const spine = areas.find((content) => content.name === 'Content Spine');
  if (!spine) {
    return undefined;
  }

  const edges = spine.width > 0 ? [spine.x, spine.x + spine.width] : [spine.x];
  const foldingLines: FoldingLine[] = edges.map((x) => ({
    type: 'line',
    name: 'Spine fold',
    x1: x,
    x2: x,
    y1: 0,
    y2: page.height,
  }));

  const panelLabels = areas
    .filter((content) => content.name === 'Panel' && !!content.title)
    .map((panel) => ({ title: panel.title as string, x: panel.x, width: panel.width }));

  return { foldingLines, panelLabels };
}

export default getCoverGuides;
